let PLATFORM = "";

PLATFORM = "web";

export { PLATFORM };
